export enum LmsProfileTypes {
  participants = 1,
  segments = 2,
  allUsers = 3,
}
